import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { authSelector, userSelector, setProfileAction } from '../store';
import { authProvider } from '../auth';


function AccountPage() {
  const { t } = useTranslation();
  const auth = useSelector(authSelector);
  const profile = useSelector(userSelector);
  const dispatch = useDispatch();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [saving, setSaving] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (profile) {
      setFirstName(profile.first_name || '');
      setLastName(profile.last_name || '');
    }
  }, [profile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccessMessage('');
    setErrorMessage('');
    try {
      const res = await authProvider.request(auth, 'patch', '/api/me/', {
        first_name: firstName,
        last_name: lastName,
      });
      dispatch(setProfileAction(res.data));
      setSuccessMessage(t('settings.saved'));
    } catch {
      setErrorMessage(t('settings.error'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page-content">
      <div className="page-content-inner">
        <div className="uk-width-1-3@m m-auto" style={{ paddingTop: '48px', paddingBottom: '48px' }}>
          <div
            style={{
              background: 'var(--card-bg, #fff)',
              borderRadius: '12px',
              boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
              padding: '36px 40px',
            }}
          >
            <div className="mb-4" style={{ textAlign: 'center' }}>
              <div style={{ marginBottom: '12px' }}>
                <span style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '52px',
                  height: '52px',
                  borderRadius: '50%',
                  background: 'rgba(var(--color-primary-rgb, 29, 161, 242), 0.1)',
                }}>
                  <i className="icon-feather-settings" style={{ fontSize: '22px', color: 'var(--color-primary, #1da1f2)' }}></i>
                </span>
              </div>
              <h2 className="mb-0" style={{ fontSize: '22px', fontWeight: '700' }}>{t('menu.settings')}</h2>
              <p className="my-0" style={{ color: 'var(--text-secondary, #6b7280)', fontSize: '14px', marginTop: '4px' }}>
                {t('settings.description')}
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              {successMessage && (
                <div className="alert alert-success mb-3" role="alert">{successMessage}</div>
              )}
              {errorMessage && (
                <div className="alert alert-danger mb-3" role="alert">{errorMessage}</div>
              )}

              <div className="uk-form-group">
                <label className="uk-form-label">{t('fields.first_name')}</label>
                <div className="uk-position-relative w-100">
                  <span className="uk-form-icon">
                    <i className="icon-feather-user"></i>
                  </span>
                  <input
                    className="uk-input"
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    placeholder={t('fields.first_name')}
                  />
                </div>
              </div>

              <div className="uk-form-group">
                <label className="uk-form-label">{t('fields.last_name')}</label>
                <div className="uk-position-relative w-100">
                  <span className="uk-form-icon">
                    <i className="icon-feather-user"></i>
                  </span>
                  <input
                    className="uk-input"
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    placeholder={t('fields.last_name')}
                  />
                </div>
              </div>

              <button
                type="submit"
                className="btn btn-default"
                disabled={saving}
                style={{ width: '100%', marginTop: '4px', opacity: saving ? 0.7 : 1 }}
              >
                {saving ? '...' : t('buttons.submit')}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountPage;
